import * as React from "react";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Slide from "@mui/material/Slide";
import ViewDataGrid from "../../grid/ViewDataGrid";
import { grnPoSummary } from "../../grid/GridData";
import { useStyles } from "../../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { Box, IconButton } from "@mui/material";
import PopUp from "../../popup/PopUp";
import { AnyForNow } from "../../../features/grn/types";

interface PurchaseOrderItemsPopUpProps {
  open: boolean;
  handleClose: () => void;
}

const PurchaseOrderItemsPopUp: React.FC<PurchaseOrderItemsPopUpProps> = ({
  open,
  handleClose,
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [filteredRows, setFilteredRows] = useState(grnPoSummary.rows);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("md");

  const content = (
    <>
      {" "}
      <Box sx={styles.grn_popup_page_container}>
        <ViewDataGrid
          columns={grnPoSummary.columns}
          // rows={rows}
          rows={filteredRows.map((item) => ({ ...item, id: item.field }))}
          //   menuItems={menuItems}
          // tabletitle={sampleData.name}
          displayActions={false}
          gridid="field"
        />
      </Box>
    </>
  );

  const actions = (
    <>
      <Button
        variant="outlined"
        sx={styles.btn_secondary}
        onClick={handleClose}
      >
        Cancel
      </Button>
      <Button variant="contained" sx={styles.btn_primary} onClick={handleClose}>
        Select
      </Button>
    </>
  );
  return (
    <PopUp
      open={open}
      handleClose={handleClose}
      title="Purchase Orders"
      content={content}
      actions={actions}
      maxWidth="md"
    />
  );
};

export default PurchaseOrderItemsPopUp;
